module.exports = __webpack_public_path__ + "static/img/MS06.15a7342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/MS06.jpg
// module id = 7qUC
// module chunks = 9